import React from "react";
import { Box, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from "@mui/material";

const VERDE = "#0e6b6b";

// Tabla de últimos registros con el mismo estilo que la de cheques: barra de título, encabezado
// claro con línea verde y filas alternadas. `columnas`: [{ h, render(fila), align }].
// `paginado` (opcional) es lo que devuelve usePaginado.
export default function ListadoTabla({ titulo, columnas, filas, cargando, vacio = "No existen registros.", paginado, color = VERDE }) {
  return (
    <Paper variant="outlined" sx={{ mt: 1, overflow: "hidden" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, px: 1, py: 0.5, bgcolor: color, color: "#fff" }}>
        <Typography sx={{ fontSize: 12.5, fontWeight: 800, letterSpacing: 0.5 }}>{titulo}</Typography>
        {cargando && <CircularProgress size={14} sx={{ color: "#fff" }} />}
      </Box>
      <TableContainer>
        <Table size="small" stickyHeader sx={{ "& .MuiTableCell-root": { py: 0.2, px: 0.5, fontSize: 11 }, "& tbody tr:nth-of-type(even)": { bgcolor: "action.hover" } }}>
          <TableHead>
            <TableRow>
              {columnas.map((c) => (
                <TableCell key={c.h} align={c.align} sx={{ fontWeight: 800, whiteSpace: "nowrap", bgcolor: `${color}1f`, color: (t) => (t.palette.mode === "dark" ? "text.primary" : color), borderBottom: `2px solid ${color}` }}>{c.h}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {!filas.length ? (
              <TableRow><TableCell colSpan={columnas.length}><Typography variant="body2" color="text.secondary">{vacio}</Typography></TableCell></TableRow>
            ) : filas.map((f) => (
              <TableRow key={f.id} hover>
                {columnas.map((c) => <TableCell key={c.h} align={c.align} sx={c.sx}>{c.render(f)}</TableCell>)}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {paginado && <PiePaginacion paginado={paginado} />}
    </Paper>
  );
}

// Pie con filas por página y navegación (página 1 = primera).
export function PiePaginacion({ paginado }) {
  return (
    <TablePagination
      component="div" count={paginado.total} page={paginado.page - 1} rowsPerPage={paginado.pageSize} rowsPerPageOptions={[10, 15, 25, 50, 100]}
      onPageChange={(_, p) => paginado.setPage(p + 1)} onRowsPerPageChange={(e) => paginado.cambiarPageSize(Number(e.target.value))}
      labelRowsPerPage="Filas" labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
      sx={{ borderTop: 1, borderColor: "divider", "& .MuiTablePagination-toolbar": { minHeight: 36 }, "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": { fontSize: 11.5, m: 0 } }}
    />
  );
}
